// extracted by mini-css-extract-plugin
export default {"tabs-container":"tabs_tabs-container__7N+XG","tabs":"tabs_tabs__pJ3wo","tab":"tabs_tab__SBeYZ","active":"tabs_active__hhusq","tab-content":"tabs_tab-content__zmiiC"};